document.addEventListener('DOMContentLoaded', () => {
	const $tabsContainers = document.querySelectorAll('.tabs');

	$tabsContainers.forEach(($container) => {
		const $tabs = $container.querySelectorAll('.tab');
		const $tabContents = $container.parentNode.querySelectorAll('.tab-content');

		$tabs.forEach(($tab) => {
			$tab.addEventListener('click', () => {
				$tabs.forEach(($currentTab) => {
					$currentTab.classList.remove('is-active');
				});

				$tabContents.forEach(($tabContent) => {
					$tabContent.classList.remove('is-active');
				});

				$tab.classList.add('is-active');
				let target = $tab.getAttribute('data-tab');
				let $tabTarget = document.getElementById(target);
				if (target && $tabTarget) {
					$tabTarget.classList.add('is-active');
				}
			});
		});
	});
});
